import React from 'react';
import s from './EventTypes.module.scss';
import { ActionButton } from '../../ActionButton/ActionButton';
import { eventTypes } from './config';
import { useLandingPageContext } from '../../../context';
import Centralizer from '../../../../../components/Centralizer/Centralizer';
import { Stack } from '@mui/material';

export const EventTypesMobile = () => {
  const { source } = useLandingPageContext();
  if (source !== 'customer') return null;

  return (
    <section section-order={2}>
      <div className={s.section}>
        <h2 data-animation>
          {/* All event industry in single catalog. Create <span>any event</span>{' '}
          you want. */}
          {/* Single catalog to plan anything from <span>wedding</span> to{' '}
            <span>corporate</span> events */}
          {/* Find reliable service providers and create <span>any event</span> you
          want */}
          {/* Explore offerings from <span>various businesses</span> and create the
          event you want */}
          {/* Everything for <span>your event</span> in one place */}
          {/* All event <span>vendors</span> and <span>organizers</span> in one
          catalog */}
          Plan any event <span>yourself</span> or contact <span>experts</span>{' '}
          for help
        </h2>
        <div data-animation className={s.animation}>
          <div className={s.slider}>
            {eventTypes.map((slide, index) => (
              <div key={index} className={s.slide}>
                <div
                  className={s.slideImageContainer}
                  style={{
                    backgroundImage: `url(${slide.src})`,
                    width: '240px',
                    height: '240px',
                  }}
                >
                  <Centralizer enableVerticalCentralization>
                    <p
                      className={s.slideOverlappedText}
                      data-text={slide.text.toUpperCase()}
                    >
                      {slide.text.toUpperCase()}
                    </p>
                  </Centralizer>
                </div>

                <ul className={s.list_goods}>
                  {slide.services.map((serviceName, index) => (
                    <li key={index}>
                      <Stack
                        spacing={1}
                        direction="row"
                        justifyContent="center"
                        className={s.listItemText}
                      >
                        <p style={{ fontSize: '10px' }}>✦</p>
                        <p>{serviceName}</p>
                      </Stack>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <span>
            <ActionButton />
          </span>
        </div>
      </div>
    </section>
  );
};
